import React from 'react';
import PropTypes from 'prop-types';
import QPureComponent from 'QPureComponent';
import { connect } from 'react-redux';
import { replace } from 'connected-react-router';

import CircularProgress from '@material-ui/core/CircularProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';
import QDialogs from 'components/QDialogs';
import Fade from '@material-ui/core/Fade';
import Zoom from '@material-ui/core/Zoom';
import ZeroStateView from 'components/ZeroStateView';
import zeroStateIcon from 'assets/zero-state-images/safebox.svg';
import QButton from 'components/QButton';

import queryString from 'query-string';
import compose from 'recompose/compose';
import * as sessionStorageEx from 'utils/sessionStorageEx';

import { Config, HOSTNAME, ENVIRONMENT } from 'utils/webappConfig';
import injectSaga from 'utils/injectSaga';

import { getAccountsById, getLoadPending as getAccountsLoadPending } from 'data/accounts/selectors';
import { getAccounts } from 'data/accounts/actions';
import { getProfile } from 'data/profile/actions';
import { getDatasets } from 'data/datasets/actions';

import * as selectors from 'data/datasets/selectors';

import { getPreferences as getPreferencesAction } from 'data/preferences/actions';
import * as preferencesSelectors from 'data/preferences/selectors';
import {
  authLogout as authLogoutAction,
  getOAuthToken,
  authSelectDataset as authSelectDatasetAction,
} from 'utils/auth/actions';
import * as authSelectors from 'utils/auth/selectors';
import { AuthSelectDatasetPayload } from 'utils/auth/types';
import * as entitlementsSelectors from 'data/entitlements/entitlementsSelectors';
import { getLogger } from 'utils/logger';
import { v4 as uuidv4 } from 'uuid';
import tracker from 'utils/tracker';

import { isAcme } from 'isAcme';

import saga from './saga';

const isIe = require('is-iexplorer');  // eslint-disable-line


const log = getLogger('containers/App/Login/index.js');

const styles = (theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  spinner: {
    color: theme.palette.primaryBlue,
  },
  formControl: {
    margin: theme.spacing(),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  listItem: {

  },
  listItemGutters: {
    paddingLeft: 24,
    paddingRight: 24,
  },
  title: {
    height: 64,
    padding: '0 24px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  dialogPaper: {
    flex: '1 1 0',
    maxWidth: 460,
  },
});

class Login extends QPureComponent {

  constructor(props) {
    super(props);

    this.state = {
      datasetSelected: false,
      ranDefaultDatasetHandler: false,
    };
  }

  componentWillMount() {
    //
    // This component is both a launching point for the external QCS login widget and also
    // the component which handles the QCS login callback. We determine which mode we are
    // in based on whether the 'code' query parameter is set.
    const query = queryString.parse(this.props.location.search);
    const parts = query.force && query.force.split('?');
    const answer = parts && parts[parts.length - 1];
    const queryForce = answer ? queryString.parse(answer) : '';
    if (query.go_back) {
      this.props.history.goBack();
    } else if (query.code || queryForce.code) {
      const localSessionState = sessionStorageEx.getSessionState();
      const remoteSessionState = query.session_state && atob(decodeURIComponent(query.session_state));
      if (remoteSessionState && (!localSessionState || localSessionState === remoteSessionState)) {
        if (query.code){
          tracker.track(tracker.events.authWidgetRedirect, query)
          this.props.getOAuthToken(query.code)
        } else {
          this.props.getOAuthToken(queryForce.code);
          tracker.track(tracker.events.authWidgetRedirect, queryForce);
        }
      } else {
        this.launchAuthWidget({session_mismatch: 1});
      }
    } else {
      this.launchAuthWidget(query);
    }
  }

  launchAuthWidget = (query = {}) => {
    const sessionState = uuidv4();
    sessionStorageEx.setSessionState(sessionState);
    const sessionStateParam = sessionState === sessionStorageEx.getSessionState() ? `&session_state=${encodeURIComponent(btoa(sessionState))}` : '';

    let message = '';
    if (query.inactive) {
      message = '&inactive=1';
    } else if (query.expired) {
      message = '&expired=1';
    } else if (query.session_mismatch) {
      message = '&session_mismatch=1';
    }

    const redirectUri = query.force || Config.hosts[HOSTNAME].redirect_uri;
    const pageType = query.signup ? 'signup' : 'signin';
    const qcsSignInUri = `${Config.environments[ENVIRONMENT].signin_url}/${pageType}?client_id=${Config.environments[ENVIRONMENT].client_id}&response_type=code&redirect_uri=${redirectUri}${message}${sessionStateParam}${query['acme-token'] ? '&acme-token=1' : ''}${query['sign-in-only'] ? '&sign-in-only=1' : ''}`;

    tracker.track(query.signup ? tracker.events.signUp : tracker.events.signIn, query);

    // launch QCS login widget
    this.props.history.replace('/login?go_back=1');
    window.location.href = qcsSignInUri;
  }

  componentWillReceiveProps(nextProps) {
    const { authenticated: wasAuthenticated } = this.props;
    const { authenticated } = nextProps;

    // if we are moving from logged out to logged in state, retrieve data required for startup
    if (!wasAuthenticated && authenticated) {
      nextProps.getDatasets();
      nextProps.getProfile();
      nextProps.getUserPreferences();
    }

    if (authenticated
      && (!nextProps.isDatasetsLoadPending)
      && (!nextProps.preferencesLoadPending.shared.user || nextProps.preferencesError)
    ) {
      this.defaultDatasetHandling(nextProps);
    }
  }

  // TODO: The Dataset Handling needs Work.
  //   - When no dataset exists,
  //     - If companion APP, point user to product...
  //     - If web first, allow user to specify parameters for dataset creation
  //   - When 1+ Datasets, Allow User to Select which Dataset
  //     - Includes Option to Create New Dataset
  //   - Perhaps give ability to Settings Datasets at this Time
  //     - Create / Modify / Delete

  defaultDatasetHandling = (props) => {

    const {datasets, redirect } = props;

    if (!this.state.ranDefaultDatasetHandler) {
      log.debug('Datasets in account are', datasets.toJS());
      this.setState({ ranDefaultDatasetHandler: true });
      const query = queryString.parse(props.location.search);

      const withoutQueries = query.force && query.force.substring(0, query.force.lastIndexOf('?'));
      const pathParts = (withoutQueries && withoutQueries.split('/').length >= 4) && withoutQueries.split('/').slice(3);
      const location = pathParts ? `/${pathParts.join('/')}` : '/';

      const numDatasets = datasets.size;
      if (numDatasets === 0) {

        if (isAcme) {
          redirect('/get-started');
        } else {
          redirect('/setup');
        }

      } else if (numDatasets >= 1) {
        this.selectDataset(datasets.first(), location);
      }
    }
  };

  selectDataset = (dataset, location) => {
    this.props.authSelectDataset(new AuthSelectDatasetPayload({ dataset, reload: false, location }));
    this.setState({ datasetSelected: true });
  };

  render() {
    const debug = super.render();

    const { isDatasetsLoadPending, datasets, entitlement, isEntitlementsLoading, flagsLoading,
      classes, authError } = this.props;
    const { datasetSelected, ranDefaultDatasetHandler } = this.state;

    log.log('datasets...', datasets.valueSeq().toJS());

    return (
      <div className={classes.root}>
        {debug}

        {(isDatasetsLoadPending || isEntitlementsLoading || flagsLoading || datasetSelected) && !authError &&
        <CircularProgress
          size={120}
          className={classes.spinner}
        />
        }

        <Fade in={Boolean(authError)} unmountOnExit mountOnEnter>
          <ZeroStateView
            icon={zeroStateIcon}
            primary="Authorization Error"
            secondary="Try to sign in again"
            useSmallerFont
            textOnTop
          >
            <Zoom in style={{transitionDelay: '300ms'}}>
              <QButton
                id="sign-in-button"
                aria-label="Login"
                variant="outlined"
                onClick={this.launchAuthWidget}
              >
                SIGN IN
              </QButton>
            </Zoom>
          </ZeroStateView>
        </Fade>

        {!isDatasetsLoadPending && datasets.size > 0 && entitlement && !datasetSelected && ranDefaultDatasetHandler &&
          <Dialog
            open={!datasetSelected}
            classes={{
              paper: classes.dialogPaper,
            }}
          >
            <DialogTitle className={classes.title}>Select Finances</DialogTitle>
            <List>
              {datasets.valueSeq().map((dataset) => (
                <ListItem
                  classes={{
                    root: classes.listItem,
                    gutters: classes.listItemGutters,
                  }}
                  button
                  onClick={() => this.selectDataset(dataset)}
                  key={dataset.id}
                >
                  <ListItemText primary={dataset.name} />
                </ListItem>
              ))}
            </List>
          </Dialog>
        }
      </div>
    );
  }
}

Login.propTypes = {
  location: PropTypes.object,
  classes: PropTypes.object,

  datasets: PropTypes.object,
  isDatasetsLoadPending: PropTypes.bool,

  getProfile: PropTypes.func,
  getAccounts: PropTypes.func,

  getDatasets: PropTypes.func,
  authSelectDataset: PropTypes.func,
  getUserPreferences: PropTypes.func,
  preferencesLoadPending: PropTypes.object,
  preferencesError: PropTypes.object,

  authenticated: PropTypes.bool,
  getOAuthToken: PropTypes.func,

  authLogout: PropTypes.func,
  redirect: PropTypes.func,

  dispatchGetEntitlementsAction: PropTypes.func,
  dispatchGetSubscriptionsAction: PropTypes.func,
  isEntitlementsLoading: PropTypes.bool,
  entitlement: PropTypes.object,

  getAccountsById: PropTypes.object,
  getAccountsLoadPending: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location,
    authenticated: authSelectors.isAuthenticated(state),
    authError: authSelectors.getError(state),
    datasetId: authSelectors.getDatasetId(state),
    datasets: selectors.getSortedDatasets(state),
    isDatasetsLoadPending: selectors.getLoadPending(state),
    isEntitlementsLoading: entitlementsSelectors.isLoading(state),
    entitlement: entitlementsSelectors.getTopTierEntitlement(state),
    preferencesLoadPending: preferencesSelectors.getLoadPending(state),
    preferencesError: preferencesSelectors.getError(state),
    getAccountsById: getAccountsById(state),
    getAccountsLoadPending: getAccountsLoadPending(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    authLogout: (data) => dispatch(authLogoutAction(data)),
    authSelectDataset: (dataset) => dispatch(authSelectDatasetAction(dataset)),
    getDatasets: () => dispatch(getDatasets()),
    getOAuthToken: (data) => dispatch(getOAuthToken(data)),
    getProfile: () => dispatch(getProfile()),
    getAccounts: () => dispatch(getAccounts()),
    getUserPreferences: () => dispatch(getPreferencesAction({ section: 'shared', group: 'user' })),
    redirect: (location) => dispatch(replace(location)),
  };
}

export default compose(
  withStyles(styles, {withTheme: true}),
  injectSaga({ key: 'login', saga }),
  QDialogs(),
  connect(mapStateToProps, mapDispatchToProps),
)(Login);

